module.exports = __webpack_public_path__ + "static/img/6.a9c1cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/6.png
// module id = q0Rj
// module chunks = 0